var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"authenticated-route"}},[_c('Navbar'),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('Sidebar'),_c('b-col',{staticClass:"py-4 px-md-5",attrs:{"cols":"12","md":"9","xl":"10"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }